/** Convierte la base pública de Vite en el basename esperado por React Router. */
export function browserRouterBasename(baseUrl: string): string {
  const normalized = baseUrl.startsWith('/') ? baseUrl : `/${baseUrl}`;
  return normalized.replace(/\/+$/, '') || '/';
}
